const faviconMap = {
  staging: '/adshines-favicon-staging.png',
  production: '/adshines-favicon.png',
}

type REACT_APP_ENV = 'staging' | 'production'

export function setFaviconFromEnv() {
  const env = (process.env.REACT_APP_ENV || 'production') as REACT_APP_ENV

  if (!(env in faviconMap)) return

  if (!['staging', 'production'].includes(env)) {
    return
  }
  const favicon = faviconMap[env] || faviconMap['production']

  if (!favicon) {
    return
  }

  const link =
    document.querySelector<HTMLLinkElement>('link[rel~="icon"]') ??
    document.createElement('link')

  link.href = favicon
  link.rel = 'icon'

  if (!link.parentNode) document.head.appendChild(link)
}
